import { Box, css } from 'theme-ui';
import styled from '../../lib/transient-styled';

export const Container = styled(Box)(
  css({
    mb: ['60px', '60px', '90px'],
    flexGrow: 1,
    '& .image-gallery-fullscreen-button': {
      left: 0,
      right: 'auto',
    },
  }),
);

export const Image = styled.img(
  css({
    objectPosition: '50% 50%',
    objectFit: 'contain',
    width: '100%',
  }),
  ({ $styleHeight }) =>
    css({
      height: $styleHeight ? `${$styleHeight}px` : '100%',
    }),
  ({ $isModifiedImageOnPrint }) =>
    css({
      '@media print': $isModifiedImageOnPrint
        ? {
            width: '70%',
            height: 'auto',
            margin: '0 auto',
          }
        : {},
    }),
);

export const StaticImage = styled.img(
  css({
    marginBottom: '10px',
    width: '100%',
  }),
);

export const Wrapper = styled.div(
  css({
    lineHeight: 0,
    overflow: 'hidden',
    position: 'relative',
    whiteSpace: 'nowrap',
    textAlign: 'center',
  }),
);
